import { useEffect, useState } from "react";
import { projectsAPI } from "../../api/client";
import { usePermission } from "../../hooks/usePermission";
import { PERMISSIONS } from "../../constants/permissions";

export default function ProjectTeamSection({
  project,
  onAllocate,
  onRemoveAllocation,
  loading,
  isAdmin,
}) {
  const [allocateUserId, setAllocateUserId] = useState("");
  const [eligibleUsers, setEligibleUsers] = useState([]);
  const hasAssignPermission = usePermission(PERMISSIONS.PROJECT_ASSIGN_USERS);
  const canManageAllocations = isAdmin || hasAssignPermission;

  useEffect(() => {
    if (!canManageAllocations) return;
    projectsAPI
      .allocationEligibleUsers()
      .then((res) => setEligibleUsers(res.data || []))
      .catch(() => {});
  }, [canManageAllocations]);

  const allocatedUsers = (project?.allocatedUsers || []).filter(
    (user) => !user.isAdmin,
  );

  return (
    <div className="left-panel-section left-panel-section--team">
      <span className="left-panel-label">Team</span>

      <div className="team-list">
        {allocatedUsers.length === 0 && (
          <p className="left-panel-empty">No users allocated</p>
        )}
        {allocatedUsers.map((user) => (
          <div key={user.id} className="team-member-row">
            <div className="team-member-avatar">
              {user.firstName?.[0]}
              {user.lastName?.[0]}
            </div>
            <div className="team-member-info">
              <span className="team-member-name">
                {user.firstName} {user.lastName}
              </span>
              <span className="team-member-role">
                {user.roles?.[0]?.name || user.role?.name || ""}
              </span>
            </div>
            {canManageAllocations && (
              <button
                className="team-member-remove"
                onClick={() => onRemoveAllocation(user.id)}
                disabled={loading}
                title="Remove"
              >
                x
              </button>
            )}
          </div>
        ))}
      </div>

      {canManageAllocations && (
        <div className="team-allocate-row">
          <select
            value={allocateUserId}
            onChange={(e) => setAllocateUserId(e.target.value)}
            className="allocate-select"
          >
            <option value="">+ Allocate user...</option>
            {eligibleUsers.map((user) => (
              <option key={user.id} value={user.id}>
                {user.firstName} {user.lastName}
                {user.roles?.[0]?.name ? ` (${user.roles[0].name})` : ""}
              </option>
            ))}
          </select>
          <button
            className="btn-primary allocate-btn"
            disabled={loading || !allocateUserId}
            onClick={() => {
              if (!allocateUserId) return;
              onAllocate(allocateUserId);
              setAllocateUserId("");
            }}
          >
            Add
          </button>
        </div>
      )}
    </div>
  );
}
